
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M30 .5v59M36 5.1l-5.81 5.8M24 5.1l5.81 5.8M24 54.9l5.81-5.8M36 54.9l-5.81-5.8M59.5 30H.5M54.9 36l-5.8-5.81M54.9 24l-5.8 5.81M5.1 24l5.8 5.81M5.1 36l5.8-5.81M50.86 9.14L9.14 50.86M51.85 16.63h-8.21M43.37 8.15v8.21M8.15 43.37h8.21M16.63 51.85v-8.21M50.86 50.86L9.14 9.14M43.37 51.85v-8.21M51.85 43.37h-8.21M16.63 8.15v8.21M8.15 16.63h8.21"}})])
          )
        }
      }
    